import React, { useCallback, useMemo } from 'react';
import { Field } from 'formik';

import classNames from 'classnames';
import { SidekickCategories } from '../../../static/categories';
import Category from './category/Category';


const ServicesCategory = ({ values, setValues, errors, touched, name, handleChange }) => {
    const categories = Object.keys(SidekickCategories)

    const handleChangeCategory = useCallback(
        category => {
            setValues(prevValues => ({
                ...prevValues,
                [name]: values[name] !== category ? category : '',
            }));
        },
        [values, setValues, name]
    );

    const getButtonsCategory = () =>
        categories.map(category => {
            const isChosenCategory = values.category === SidekickCategories[category].uid;

            return (
                <Category
                    key={`${SidekickCategories[category].uid}-buttons-category`}
                    onChange={handleChangeCategory}
                    label={SidekickCategories[category].label}
                    isChosenCategory={isChosenCategory}
                    category={category}
                />
            );
        });

    const buttonsCategory = useMemo(() => getButtonsCategory(), [getButtonsCategory]);

    const categoryHeaderClass = classNames({
        categoryHeader: true,
        'header-error': errors[name] && touched[name],
    });

    return (
        <>
            <h2 className={categoryHeaderClass}>Select a category</h2>
            <div className="categoriesWrapper">
                <Field
                    name={name}
                    onChange={handleChange}
                    value={values[name]}
                    className="inputCategory"
                />
                {buttonsCategory}
            </div>
        </>
    );
};

export default ServicesCategory;
